<template>
  <div>
    <b-list-group flush>
      <tree-view-item v-for="(node, idx) in items" :key="idx" :node="node" />
    </b-list-group>
  </div>
</template>

<script>
import TreeViewItem from "@/layouts/components/common/TreeViewItem.vue";
import { BListGroup } from "bootstrap-vue";

export default {
  name: "TreeViewFolder",
  components: {
    BListGroup,
    TreeViewItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedNode: null,
    };
  },
  methods: {
    selectNode(node) {
      this.selectedNode = node;
    },
    isNodeSelected(node) {
      return this.selectedNode === node;
    },
  },
  provide() {
    return {
      selectNode: this.selectNode,
      isNodeSelected: this.isNodeSelected,
    };
  },
  watch: {
    selectedNode(newValue) {
      this.$emit("selectedNode", newValue);
    },
  },
};
</script>

<style scoped>
.tree-item {
  cursor: pointer;
  user-select: none;
}
</style>
